module.exports = __webpack_public_path__ + "img/ch58.0f8db480.png";